// Navigation
/* Set the width of the side navigation to 250px and the left margin of the page content to 250px and add a black background color to body */
function openNav() {
    document.getElementById("side-navigation").style.width = "350px";
    var sideNav = document.getElementById("side-navigation");
    var overlay = document.getElementById("sidenav-overlay");
    overlay.style.display = "block";
  
    // Add event listener to close the menu when clicking outside
    document.addEventListener('click', closeNavOutside);
  
      // Prevent clicks inside the menu from triggering the document click event
      sideNav.addEventListener('click', function(event) {
      event.stopPropagation();
    });
  }
  
  /* Set the width of the side navigation to 0 and the left margin of the page content to 0, and the background color of body to white */
  function closeNav() {
    document.getElementById("side-navigation").style.width = "0";
    var overlay = document.getElementById("sidenav-overlay");
    overlay.style.display = "none";
  
    // Remove the event listener after closing the menu
    document.removeEventListener('click', closeNavOutside);
  }
  
  // Function to close the menu when clicking outside
  function closeNavOutside(event) {
    var sideNav = document.getElementById("side-navigation");
  
    // Check if the clicked element is not part of the menu or the burger icon
    if (
      event.target.closest('#side-navigation') === null &&
      event.target.closest('#burger-icon') === null
    ) {
      closeNav();
    }
  }
  
  // Get the burger icon and add an event listener to open the menu
  document.getElementById("burger-icon").addEventListener('click', openNav);
  
  function toggleSubMenu(link) {
      var subMenu = link.nextElementSibling;
      var allSubMenus = document.querySelectorAll('.sidenav .sub-menu');
      var allLinks = document.querySelectorAll('.sidenav a');
  
      // Close all other sub-menus and remove 'active' class from links
      var parentMenu = link.closest('.sub-menu');
var siblingMenus = parentMenu ? parentMenu.querySelectorAll(':scope > .sub-menu') : [];

siblingMenus.forEach(function (menu) {
  if (menu !== subMenu) {
    menu.classList.remove('active');
  }
});

  
      allLinks.forEach(function (menuLink) {
          menuLink.classList.remove('active-link');
      });
  
      // Toggle the 'active' class to expand/collapse the clicked sub-menu
      subMenu.classList.toggle('active');
  
      // Toggle the 'active-link' class to change the color of the clicked link
      link.classList.toggle('active-link');
  }
  
  // Cart Slider
  /* Set the width of the side navigation to 250px and the left margin of the page content to 250px and add a black background color to body */
  function openCart() {
    document.getElementById("cart-slider").style.width = "350px";
    var cartSlide = document.getElementById("cart-slider");
    var cartSliderOverlay = document.getElementById("cart-slider-overlay");
    cartSliderOverlay.style.display = "block";
  
    // Add event listener to close the menu when clicking outside
    document.addEventListener('click', closeCartOutside);
  
      // Prevent clicks inside the menu from triggering the document click event
      cartSlide.addEventListener('click', function(event) {
      event.stopPropagation();
    });
  }
  
  // Close the cart drawer when clicking outside of it
document.getElementById("cart-slider-overlay").addEventListener('click', function() {
    closeCart();
});
  
  // Get the burger icon and add an event listener to open the menu
  document.getElementById("cart-icon").addEventListener('click', openCart);
  
  // Search Bar
  document.getElementById('search-icon').addEventListener('click', function () {
    var searchContainer = document.getElementById('search-bar-container');
    searchContainer.style.display = 'block';
    searchContainer.style.height = '0px';
    setTimeout(function () {
      searchContainer.style.height = '65px';
    }, 10);
  });


  
  document.getElementById('close-icon').addEventListener('click', function () {
    var searchContainer = document.getElementById('search-bar-container');
    searchContainer.style.height = '0';
    setTimeout(function () {
      searchContainer.style.display = 'none';
    }, 500);
  });
  
  // Search Bar Mobile
  document.getElementById('mobile-search-icon').addEventListener('click', function () {
    var searchContainer = document.getElementById('search-bar-container');
    searchContainer.style.display = 'block';
    searchContainer.style.height = '0px';
    setTimeout(function () {
      searchContainer.style.height = '65px';
    }, 10);
  });
  
  document.getElementById('close-icon').addEventListener('click', function () {
    var searchContainer = document.getElementById('search-bar-container');
    searchContainer.style.height = '0';
    setTimeout(function () {
      searchContainer.style.display = 'none';
    }, 500);
  });

  // Categories Sidebar
  document.addEventListener('DOMContentLoaded', function () {
    var parentLinks = document.querySelectorAll('.parent-link');

    parentLinks.forEach(function (parentLink) {
        parentLink.addEventListener('click', function () {
            var submenu = this.querySelector('.submenu');
            submenu.style.maxHeight = submenu.style.maxHeight ? null : submenu.scrollHeight + 'px';
        });
    });
});



let isUpdating = false; // Flag to control update flow

document.addEventListener('DOMContentLoaded', function() {
    // Attach event listeners to quantity buttons to prevent form submission
    document.querySelectorAll('.quantity-btn').forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent form submission
            if(isUpdating) return; // Prevent updates while another is in progress
            const isIncrement = this.getAttribute('onclick').includes('incrementQuantity');
            if (isIncrement) {
                incrementQuantity(this);
            } else {
                decrementQuantity(this);
            }
        });
    });

    // Attach event listeners to quantity input fields to update cart on change
    document.querySelectorAll('.quantity-input').forEach(input => {
        input.addEventListener('change', function() {
            if(isUpdating) return; // Prevent updates while another is in progress
            updateCartQuantity(this);
        });
    });
});

function incrementQuantity(btn) {
    if(isUpdating) return; // Check if an update is already in progress
    var inputField = btn.parentNode.querySelector('.quantity-field');
    var currentValue = parseInt(inputField.value, 10);
    inputField.value = currentValue + 1;
    updateCartQuantity(inputField); // Update cart quantity
}

function decrementQuantity(btn) {
    if(isUpdating) return; // Check if an update is already in progress
    var inputField = btn.parentNode.querySelector('.quantity-field');
    var currentValue = parseInt(inputField.value, 10);
    if (currentValue > 1) {
        inputField.value = currentValue - 1;
        updateCartQuantity(inputField); // Update cart quantity
    }
}

function updateCartQuantity(inputField) {
    if(isUpdating) return; // Prevent duplicate updates
    isUpdating = true; // Set flag to indicate update in progress

    var quantity = inputField.value;
    var key = inputField.getAttribute('data-cart-item-key');

    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
        },
        body: JSON.stringify({
            id: key,
            quantity: parseInt(quantity, 10)
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Cart updated', data);
        isUpdating = false; // Reset flag after update
        // Optionally, refresh some parts of your page here, like cart total or item counts
    })
    .catch((error) => {
        console.error('Error:', error);
        isUpdating = false; // Reset flag if there's an error
    });
}


  // Address Modals
  function openEditAddressModal(addressId) {
  var formToClone = document.getElementById('editForm-' + addressId);
  if (formToClone) {
    var modalFormContainer = document.getElementById('modalFormContainer');
    modalFormContainer.innerHTML = formToClone.innerHTML; // Clone the form into the modal
    openModal('editAddressModal');
  } else {
    console.error('Form for address not found');
  }
}

function openModal(modalId) {
  var modal = document.getElementById(modalId);
  modal.style.display = 'flex';
}

function closeModal(modalId) {
  var modal = document.getElementById(modalId);
  modal.style.display = 'none';
}


  // Find Store
  function showStores(state) {
    var allStores = document.querySelectorAll('.store-card');
    allStores.forEach(function (card) {
        card.style.display = 'none';
    });

    var stateStores = document.querySelectorAll('.' + state);
    stateStores.forEach(function (card) {
        card.style.display = 'block';
    });
}

function showAllStores() {
    var allStores = document.querySelectorAll('.store-card');
    allStores.forEach(function (card) {
        card.style.display = 'block';
    });
}



// Product
document.addEventListener('DOMContentLoaded', function() {
  var select = document.getElementById('product-select');
  var thumbnails = document.querySelectorAll('.thumbnail');
  var mainImage = document.getElementById('main-image');
  var skuElement = document.getElementById('sku'); // Assuming you have an element with id 'sku' to display the SKU

  // Add change event listener to variant selector
  select.addEventListener('change', function() {
    var selectedVariantId = select.value;
    var selectedVariant = product.variants.find(function(variant) {
      return variant.id == selectedVariantId;
    });

    // Update the product price
    if (selectedVariant) {
      var formattedPrice = Shopify.formatMoney(selectedVariant.price, '');
      document.querySelector('.product-page-price').textContent = formattedPrice;

      // Update main image source to variant image if it exists
      if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
        mainImage.src = selectedVariant.featured_image.src;
      }

      // Update the SKU
      if (skuElement) {
        skuElement.textContent = selectedVariant.sku;
      }

      // Update the URL to include the selected variant
      var url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariantId);
      window.history.pushState({}, '', url);
    }
  });

  // Add click event listener to each thumbnail
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      // Update main image source to clicked thumbnail's source
      mainImage.src = thumbnail.src;
    });
  });

  // Get the initial selected variant and update the main image
  var initialVariantId = select.value;
  var initialVariant = product.variants.find(function(variant) {
    return variant.id == initialVariantId;
  });

  if (initialVariant && initialVariant.featured_image && initialVariant.featured_image.src) {
    mainImage.src = initialVariant.featured_image.src;
  }
});

// Quantity Adjuster
document.addEventListener('DOMContentLoaded', function() {
  var minusButton = document.querySelector('.quantity-selector-product .quantity-button-product:first-child');
  var plusButton = document.querySelector('.quantity-selector-product .quantity-button-product:last-child');
  var quantityField = document.querySelector('.quantity-selector-product .quantity-field-product');

  // Add click event listener to decrease quantity
  minusButton.addEventListener('click', function() {
    var currentValue = parseInt(quantityField.value);
    if (currentValue > 1) {
      quantityField.value = currentValue - 1;
    }
  });

  // Add click event listener to increase quantity
  plusButton.addEventListener('click', function() {
    var currentValue = parseInt(quantityField.value);
    quantityField.value = currentValue + 1;
  });
});

// Ajax
// Add an event listener to the variant select element
const variantSelect = document.getElementById('product-select');
variantSelect.addEventListener('change', function() {
    const selectedVariantId = variantSelect.value;
    document.getElementById('displ_num').innerHTML = selectedVariantId;
});


// Variable to prevent adding to cart while an operation is in progress
let isAddingToCart = false;

// Function to add the item to the cart
function addToCart(productId, quantity) {
    console.log('Adding product to cart:', productId, 'Quantity:', quantity);

    if (isAddingToCart) {
        console.log('Already adding to cart. Please wait.');
        return;
    }

    if (isNaN(quantity) || quantity <= 0) {
        console.error('Invalid quantity:', quantity);
        return;
    }

    isAddingToCart = true;

    // Use the AJAX API to add an item to the cart
    const formData = new FormData();
    formData.append('id', productId);
    formData.append('quantity', quantity);

    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(cart => {
        isAddingToCart = false;
        console.log('Item added to cart successfully:', cart);
        // Open the cart drawer
        openCart();
    })
    .catch(error => {
        isAddingToCart = false;
        console.error('Failed to add item to cart:', error);
    });
}

// Function to update the cart drawer with the cart data
function updateCartDrawer(cart) {
    const cartItemsContainer = document.querySelector('.cart-items-container');

    if (!cartItemsContainer) {
        console.error('Cart items container not found.');
        return;
    }

    cartItemsContainer.innerHTML = ''; // Clear the existing items

    // Create a number formatter for currency
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    // Iterate through the cart items and create HTML for each item
    cart.items.forEach(item => {
        const newCartItem = document.createElement('div');
        newCartItem.classList.add('cart-item');
        newCartItem.setAttribute('data-variant-id', item.variant_id);
        newCartItem.innerHTML = `
            <img src="${item.image}" alt="${item.title}">
            <div class="item-details">
                <a href="${item.url}"><h3>${item.title}</h3></a>
                <p>Price: ${currencyFormatter.format(item.price / 100)}</p>
                <p>Quantity: <span class="cart-quantity">${item.quantity}</span></p>
            </div>
        `;

        // Quantity adjuster
        const quantityAdjuster = document.createElement('div');
        quantityAdjuster.classList.add('quantity-adjuster');
        quantityAdjuster.innerHTML = `
            <div>
            <span class="quantity-button-product decrease-quantity">-</span>
            <input class="quantity-field-product" type="text" name="quantity" min="1" value="${item.quantity}">
            <span class="quantity-button-product increase-quantity">+</span>
            </div>
            <a class="remove-item" href="#" data-variant-id="${item.variant_id}">X Remove</a>
        `;

        // Attach event listeners to quantity buttons
        const decreaseQuantityButton = quantityAdjuster.querySelector('.decrease-quantity');
        const increaseQuantityButton = quantityAdjuster.querySelector('.increase-quantity');

        decreaseQuantityButton.addEventListener('click', () => {
            updateCartItemQuantity(item.variant_id, item.quantity - 1);
        });

        increaseQuantityButton.addEventListener('click', () => {
            updateCartItemQuantity(item.variant_id, item.quantity + 1);
        });

        cartItemsContainer.appendChild(newCartItem);
        cartItemsContainer.appendChild(quantityAdjuster);

        // Event listener for removing an item from the cart (on any page)
        quantityAdjuster.querySelector('.remove-item').addEventListener('click', event => {
            event.preventDefault();
            const variantId = event.target.getAttribute('data-variant-id');
            removeItemFromCart(variantId);
        });
    });

    // Update the cart subtotal
    const subtotalPrice = document.querySelector('.subtotal-price');

    if (subtotalPrice) {
        subtotalPrice.textContent = currencyFormatter.format(cart.total_price / 100);
    } else {
        console.error('Subtotal price element not found.');
    }
}

// Function to update the quantity of a cart item
function updateCartItemQuantity(variantId, quantity) {
    // Use the AJAX API to update the quantity of an item in the cart
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    fetch('/cart/change.js', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(cart => {
        console.log('Item quantity updated successfully:', cart);
        openCart();
    })
    .catch(error => {
        console.error('Failed to update item quantity:', error);
    });
}

// Function to open the cart drawer
function openCart() {
    // Use the AJAX API to get the cart data
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        updateCartDrawer(cart);
        document.getElementById("cart-slider").style.width = "350px";
        document.getElementById("cart-slider-overlay").style.display = "block";
    })
    .catch(error => {
        console.error('Failed to fetch cart data:', error);
    });
}

// Function to remove an item from the cart
function removeItemFromCart(variantId) {
    // Use the AJAX API to remove an item from the cart
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 0); // Set quantity to 0 to remove the item
    
    fetch('/cart/change.js', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(cart => {
        console.log('Item removed from cart successfully:', cart);
        // Refresh the cart drawer
        openCart();
    })
    .catch(error => {
        console.error('Failed to remove item from cart:', error);
    });
}

// Function to update the Add to Cart button based on variant inventory
function updateAddToCartButton(selectedVariantId) {
    // Use the AJAX API to fetch variant data
    fetch(`/products/product-handle.js?variant=${selectedVariantId}`, {
        method: 'GET',
    })
    .then(response => response.json())
    .then(variantData => {
        // Check if the selected variant is in stock
        const addToCartBtn = document.getElementById('add-to-cart-btn');
        if (variantData.inventory_quantity > 0) {
            addToCartBtn.style.display = 'block'; // Show the button
            addToCartBtn.disabled = false; // Enable the button
            addToCartBtn.textContent = 'Add to Cart'; // Reset the button text
        } else {
            addToCartBtn.style.display = 'none'; // Hide the button
            addToCartBtn.disabled = true; // Disable the button
            addToCartBtn.textContent = 'Out of Stock'; // Change button text
        }
    })
    .catch(error => {
        console.error('Failed to fetch variant data:', error);
    });
}

// Event listener for the add to cart button
document.getElementById('add-to-cart-btn').addEventListener('click', () => {
    const productId = document.getElementById("displ_num").innerHTML; // Fetch the product ID dynamically
    const quantityInput = document.getElementById("quantity-input");
    const quantity = quantityInput.value ? parseInt(quantityInput.value) : 1; // Default to 1 if no quantity specified
    addToCart(productId, quantity);
});

// Event listener for removing an item from the cart
document.addEventListener('click', event => {
    if (event.target.classList.contains('remove-item')) {
        event.preventDefault();
        const variantId = event.target.getAttribute('data-variant-id');
        removeItemFromCart(variantId);
    }
});

// Function to initialize the cart drawer
function initializeCartDrawer() {
    // Close the cart drawer initially
    closeCart();
}

// Function to close the cart drawer
function closeCart() {
    document.getElementById("cart-slider").style.width = "0";
    document.getElementById("cart-slider-overlay").style.display = "none";
}

// Close the cart drawer when clicking outside of it
document.getElementById("cart-slider-overlay").addEventListener('click', () => {
    closeCart();
});

// Initialize the cart drawer
initializeCartDrawer();



